import {
  container,
  cardTitle,
  whiteColor,
  grayColor
} from "assets/jss/emjayTheme.js";
import {primaryColor, dangerColor} from "assets/jss/emjayTheme";

const loginPageStyle = theme => ({
  container: {
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "100px"
    }
  },
  branding: {
    pin: {

    },
    drop: {

    }
  },
  cardTitle: {
    ...cardTitle,
    color: whiteColor
  },
  textCenter: {
    textAlign: "center"
  },
  errorText:{
    textAlign: "center",
    color: dangerColor[0]
  },
  justifyContentCenter: {
    justifyContent: "center !important"
  },
  customButtonClass: {
    "&,&:focus,&:hover": {
      color: whiteColor
    },
    marginLeft: "5px",
    marginRight: "5px"
  },
  password: {
      "& input":{
        textSecurity: 'disc',
        WebkitTextSecurity: 'disc',
        MoxTextSecurity: 'disc'
      }
  },
  inputAdornment: {
    marginRight: "18px"
  },
  inputAdornmentIcon: {
    color: grayColor[6]
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)"
  },
  cardHeader: {
    marginBottom: "20px"
  },
  socialLine: {
    padding: "0.9375rem 0"
  }
});

export default loginPageStyle;
